/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useRef, useEffect, useState, useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
// import { Chart as ChartJS, registerables } from 'chart.js';
// import { Chart } from 'react-chartjs-2'
// ChartJS.register(...registerables);
// import 'chartjs-adapter-moment';

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import Grid from "@mui/material/Grid";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Soft UI Dashboard PRO React helper functions
import gradientChartLine from "assets/theme/functions/gradientChartLine";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//Backend access
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Route, Link, Routes, useLocation, useNavigate, useMatch } from 'react-router-dom';
import moment from "moment";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";


function LiveviewSelects({ startTime, setStartTime, endTime, setEndTime }) {

    const header = (
        <SoftBox display={'flex'}>
            <SoftBox mb={1} >
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker value={moment(startTime * 1000)} maxDate={moment(endTime * 1000).clone().subtract(1, 'day')} onChange={(new_value) => { setStartTime(new_value.unix()) }} />
                </LocalizationProvider>
            </SoftBox>
            <SoftBox mb={1} pl={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker value={moment(endTime * 1000)} minDate={moment(startTime * 1000).clone().add(1, 'day')} onChange={(new_value) => { setEndTime(new_value.unix()) }} />
                </LocalizationProvider>
            </SoftBox>
        </SoftBox >
    );

    return header;

}

// Typechecking props for the LiveviewSelects
LiveviewSelects.propTypes = {
    startTime: PropTypes.number,
    setStartTime: PropTypes.func,
    endTime: PropTypes.number,
    setEndTime: PropTypes.func
};

export default LiveviewSelects;

